import { render, staticRenderFns } from "./DgaServices.vue?vue&type=template&id=1a6ec9de&"
import script from "./DgaServices.vue?vue&type=script&lang=ts&"
export * from "./DgaServices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports